import React, {FC, useState} from "react";
import {Broadcast, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const EditBroadcastAttachmentModal: FC<{ broadcast: Broadcast, onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const [attachment, setAttachment] = useState<File|null>(null)
  const {showToast} = useToasts()

  const submit = async () => {
    if (! attachment) {
      return
    }
    await broadcasts.updateAttachment(props.broadcast.id, attachment).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
    })
    props.onFinished()
  }

  return <div className={'space-y-3'}>
    <div>
      <input type={'file'} onChange={(event) => setAttachment(event.target.files?.[0] ?? null)} />
    </div>
    <ModalFooter text={'Opslaan'} isDisabled={! attachment} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}